import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Card, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router";
import { z } from "zod";

import {
    OrganizationCollection,
    OrganizationDocument,
} from "../../api/firestoreWrappers.generated.jsx";
import BackButton from "../../components/BackButton";
import { Breadcrumbs, breadcrumbPaths } from "../../components/Breadcrumbs";
import CancelButton from "../../components/CancelButton";
import TextFormGroup from "../../components/FormGroups/TextFormGroup.jsx";
import Layout, { Title } from "../../components/Layout/Layout";
import urls from "../../urls.jsx";

export default function OrganizationCreatePage() {
    const navigate = useNavigate();

    const createOrganizationConfigSchema = () =>
        z.object({
            organizationName: z
                .string()
                .min(1, { message: "Please enter a name" }),
        });

    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isSubmitting },
    } = useForm({
        resolver: zodResolver(createOrganizationConfigSchema()),
        defaultValues: {
            organizationName: "",
        },
    });

    const onSubmit = async (formData) => {
        const name = formData.organizationName;
        try {
            // 1) create the new location
            const newOrganizationId = await OrganizationCollection().add({
                name,
            });

            // 2) write back the generated id into the document
            await OrganizationDocument(newOrganizationId).update({
                id: newOrganizationId,
            });

            // 3) navigate & mark saved
            navigate(urls.organization(newOrganizationId));
        } catch (err) {
            console.error("Failed to create & save new location:", err);
        }
    };

    return (
        <Layout>
            <title>{`New Organization | MyCorvus`}</title>
            <Breadcrumbs path={breadcrumbPaths.organizationCreate} />
            <Card>
                <Title
                    title={
                        <>
                            <BackButton to={urls.organizations()} />
                            Create Organization
                        </>
                    }
                />
                <Card.Body className="p-4 py-0">
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <TextFormGroup
                            label="Organization name"
                            name="organizationName"
                            control={control}
                            errors={errors}
                        />
                        <Button
                            variant="success"
                            disabled={isSubmitting || !isDirty}
                            type="submit"
                            className="mb-3 mt-1"
                        >
                            <FaPlus className="mb-1 me-1" />
                            {isSubmitting ? "Creating..." : "Create"}
                        </Button>
                        <CancelButton
                            className="ms-2 mb-3 mt-1"
                            to={urls.organizations()}
                        />
                    </Form>
                </Card.Body>
            </Card>
        </Layout>
    );
}
